export default __webpack_public_path__ + "static/media/staff-2021.8b74ff84.png";